import Loadable from '../../components/loadable';

const StyleMembersList = Loadable({
  loader: () => import('../../pages/gradings/style_members_list'),
  type: 'block',
});

angular.module('gym').value('StyleMembersList', StyleMembersList);
